import { ASSET_PREFIX } from '../lib/constants';

export const isGcp = () => process.env.ENV !== 'local';

export const isProd = () => process.env.ENV === 'prod';

export const withPrefix = (path: string) => (isGcp() ? ASSET_PREFIX + path : path);

export const env = process.env.ENV === 'prod' ? 'prod' : 'qa';

export const localDefaultUrl = 'https://www-qa2.cvs.com';

export type DeviceType =
  | 'DESKTOP'
  | 'AND_MOBILE'
  | 'AND_GLASS'
  | 'AND_TABLET'
  | 'IOS_MOBILE'
  | 'IOS_TABLET'
  | 'MOBILE_WEB_VIEW'
  | 'WIN_MOBILE'
  | 'OTH_MOBILE';
export const getDeviceType = (): DeviceType => {
  // Other
  let deviceType: DeviceType = 'DESKTOP';
  if (typeof window !== 'undefined') {
    const ua: string = window?.navigator?.userAgent;

    // Android Specific Checks
    if (/Android/i.test(ua)) {
      // Android Mobile
      if (/Mobile/i.test(ua)) {
        deviceType = 'AND_MOBILE';
      } else if (/Glass/i.test(ua)) {
        // Android Glass
        deviceType = 'AND_GLASS';
      } else {
        // Android Tablet
        deviceType = 'AND_TABLET';
      }
    } else if (/iPhone|iPod/i.test(ua)) {
      // iOS Mobile
      deviceType = 'IOS_MOBILE';
    } else if (/iPad/i.test(ua) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)) {
      // iOS Tablet
      deviceType = 'IOS_TABLET';
    } else if (/(iPhone|iPod|iPad)(?!.*Safari)/i.test(ua) || /(Android).*wv./i.test(ua)) {
      // MOBILE WEB VIEW
      deviceType = 'MOBILE_WEB_VIEW';
    } else if (/IEMobile/i.test(ua)) {
      // Windows
      deviceType = 'WIN_MOBILE';
    } else if (/webOS|BlackBerry|Opera Mini/i.test(ua)) {
      // Other Identified Vendor
      deviceType = 'OTH_MOBILE';
    }
  }
  return deviceType;
};

export const deviceType = getDeviceType() === 'DESKTOP' ? 'dweb' : 'mweb';
